import React from 'react';
import {Card} from "antd";
import {compose} from "redux";
import {connect} from "react-redux";
import {withLoading} from "../../Boilerplate/deferLoaderHoc";
import {PunchListForm} from "./PunchListForm";
import {getPunchList, updatePunch} from "../../../actions/punchList";

const PunchListEdit = props => {
  const { punchList, projectid, onSubmit, onCancel } = props;
  return <Card title='Punch List Item Details' className={'edit-view'}>
    <PunchListForm projectid={projectid} punchList={punchList} onCancel={onCancel} onSubmit={onSubmit}/>
  </Card>;
};

export default compose(
  connect(
    (state, props) => {
      let item = state.view.subview.data[props.match.params.punchListId];
      if (!item) return { loading: true };
      return { punchList: item.resource, projectid: props.match.params.id };
    },
    (dispatch, props) => ({
      loader: () => dispatch(getPunchList(props.match.params.id, props.match.params.punchListId)),
      onSubmit: (item) => {
        dispatch(updatePunch(props.match.params.id, item));
        props.history.goBack();
      },
      onCancel: () => props.history.goBack()
    })
  ),
  withLoading
)(PunchListEdit);



// WEBPACK FOOTER //
// ./src/components/Projects/PunchList/PunchListEdit.js